/* istanbul ignore file */
import React from 'react';
import { useAssetUrl } from 'domain/finance/assets/shared/useAssetRouting';
import { CREATE_ASSET } from 'domain/finance/assets/useAssetService';
import { CreateButton } from 'framework/ui/ui-builder';

const CreateAssetButton = () => {
  const { getCreateUrl } = useAssetUrl();

  return <CreateButton url={getCreateUrl()} label="Add asset" key="create-asset" permissionToCheck={CREATE_ASSET} />;
};

export default CreateAssetButton;
